import React, { useEffect, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { InputAdornment, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";

import { InputField } from "../InputField";

import style from "./index.module.css";

import { ITimePickerType } from "@/models/doctor";

interface IProps {
  type: ITimePickerType;
  label: string;
  value: any;
  handleSaveTime: (value: string, type: ITimePickerType) => void;
  disabled?: boolean;
}

const TimePicker: React.FC<IProps> = ({
  type,
  label,
  value,
  handleSaveTime,
  disabled = false,
}) => {
  const intl = useIntl();

  const [selectedTime, setSelectedTime] = useState<null | Dayjs>(null);

  const saveSelectedValue = (values: any) => {
    const value = dayjs(values?.$d).format("HH:mm");
    handleSaveTime(value, type);
  };

  useEffect(() => {
    const selectedTimeValue = value
      ? dayjs(`${dayjs().format("YYYY-MM-DD")}T${value}`)
      : null;
    setSelectedTime(selectedTimeValue);
  }, [value]);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer
        components={["MobileTimePicker", "MobileTimePicker"]}
        sx={{ overflow: "hidden", border: "0.8rem" }}
      >
        <MobileTimePicker
          value={selectedTime}
          onChange={(event: any) => setSelectedTime(event)}
          onAccept={saveSelectedValue}
          label={intl.formatMessage({
            id: label,
            defaultMessage: "Label Name",
          })}
          openTo="hours"
          slots={{
            textField: (params) => (
              <InputField
                {...params}
                InputProps={{
                  readOnly: disabled,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography component={"p"} className={style.selectText}>
                        <FormattedMessage id="select" defaultMessage="Select" />
                      </Typography>
                    </InputAdornment>
                  ),
                }}
                fullWidth
              />
            ),
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};
export default TimePicker;
